var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.noRecords)?_c('AlertBanner',{attrs:{"message":_vm.message}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }